// src/components/ResolvedAlertsModal.js

import { useEffect, useState } from "react";
import axios from "axios";
import { getToken } from "../utils/auth";
import Modal, { DialogHeader, DialogBody } from "./ui/Modal";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export default function ResolvedAlertsModal({ onClose, resolvedAlerts: propsResolvedAlerts }) {
  const [resolvedAlerts, setResolvedAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (propsResolvedAlerts) {
      // Use passed resolved alerts (from PatientDetailPage/AlertsTab)
      setResolvedAlerts(propsResolvedAlerts);
      setLoading(false);
    } 
    else {
      // Default behavior for AlertsPage.js (fetch with authentication - filtered by doctor)
      const token = getToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      
      axios.get(`${API_BASE_URL}/resolved_alerts/`, { headers })
        .then(res => setResolvedAlerts(res.data))
        .finally(() => setLoading(false));
    }

  }, [propsResolvedAlerts]);

  return (
    <Modal open onClose={onClose} align="start">
      <div className="w-full max-w-6xl bg-white rounded-2xl shadow-2xl border border-gray-100 max-h-[86vh] overflow-hidden flex flex-col">
        <DialogHeader
          title="Resolved Alerts"
          subtitle="Archived and completed alerts for review."
          onClose={onClose}
          tone="soft"
          sticky
          closeVariant="ghost"
        />

        <DialogBody>
          {loading && <p className="px-6 py-8 text-center text-emerald-700">Loading resolved alerts...</p>}

          {!loading && resolvedAlerts.length === 0 && (
            <p className="px-6 py-8 text-center text-gray-500">No resolved alerts found.</p>
          )}

          {!loading && resolvedAlerts.length > 0 && (
            <table className="w-full text-left border-separate border-spacing-0 table-auto">
              <thead className="bg-emerald-50 sticky top-0 z-[1]">
                <tr className="border-b border-emerald-100">
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">S.No</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Alert ID</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">PMRN</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Patient Name</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Description</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Priority</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Recommendations</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Notes</th>
                  <th className="py-3 px-3 text-xs sm:text-sm font-semibold text-emerald-900">Resolved At</th>
                </tr>
              </thead>
              <tbody className="bg-white">
              {resolvedAlerts.map((alert, index) => (
                <tr key={alert.id} className="border-b border-emerald-50 hover:bg-emerald-50/40 transition-colors">
                  <td className="py-3 px-3 text-sm text-gray-700">{index + 1}</td>
                  <td className="py-3 px-3 text-sm font-medium text-gray-800">{alert.alert_id}</td>
                  <td className="py-3 px-3 text-sm text-gray-700">{alert.PMRN}</td>
                  <td className="py-3 px-3 text-sm text-gray-700">{alert.patient_name}</td>
                  <td className="py-3 px-3 text-sm text-gray-700">{alert.description}</td>
                  <td className="py-3 px-3 text-sm text-gray-700">{alert.priority}</td>
                  <td className="py-3 px-3 text-sm text-gray-700">
                    {alert.recommendations && alert.recommendations.length > 0 ? (
                    alert.recommendations.map(item => (
                      <div key={item.id}>{item.text}</div>
                    ))
                    ) : (
                    <span className="text-gray-400">—</span>
                   )}
                  </td>

                  <td className="py-3 px-3 text-sm text-gray-700">{alert.task_notes && alert.task_notes.length > 0 ? (
                    alert.task_notes.map(item => (
                      <div key={item.id}>{item.text}</div>
                    ))
                    ) : (
                    <span className="text-gray-400">—</span>
                    )}
                  </td>

                  <td className="py-3 px-3 text-sm text-gray-700 whitespace-nowrap">
                    {new Date(alert.resolved_at).toLocaleString()}
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          )}
        </DialogBody>
      </div>
    </Modal>
  );
}


// // src/components/ResolvedAlertsModal.js

// import { useEffect, useState } from "react";
// import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_API_URL;

// export default function ResolvedAlertsModal({ onClose, resolvedAlerts: propsResolvedAlerts }) {
//   const [resolvedAlerts, setResolvedAlerts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   axios.get(`${API_BASE_URL}/resolved_alerts`)
//   //     .then(res => setResolvedAlerts(res.data))
//   //     .finally(() => setLoading(false));
//   // }, []);

//   useEffect(() => {
//     if (propsResolvedAlerts) {
//       // Use passed resolved alerts (from PP.js)
//       setResolvedAlerts(propsResolvedAlerts);
//       setLoading(false);
//     } 
//     else {

//       // Default behavior for AlertPage.js (fetch all)
//       axios.get(`${API_BASE_URL}/resolved_alerts/`)
//         .then(res => setResolvedAlerts(res.data))
//         .finally(() => setLoading(false));
//     }

//   }, [propsResolvedAlerts]);

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-start z-50 overflow-y-auto py-10">
//       <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl mx-4 md:mx-auto max-h-[90vh] overflow-y-auto p-6">
 
//         {/* Header */}
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-xl font-semibold text-gray-800">Resolved Alerts</h2>
//           <button 
//             onClick={onClose}
//             className="text-gray-600 hover:text-red-500 text-lg"
//           >
//             ✕
//           </button>
//         </div>

//         {/* Loading */}
//         {loading && <p>Loading...</p>}

//         {/* Resolved Alerts Table */}
//         {!loading && (
//           <table className="w-full text-left border-collapse table-auto">
//             <thead className="bg-gray-100 sticky top-0">
//               <tr className="border-b">
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Alert ID</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">PMRN</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Patient Name</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Description</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Priority</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Recommendations</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Notes</th>
//                 <th className="py-2 px-3 text-sm font-medium text-gray-700">Resolved At</th>
//               </tr>
//             </thead>

//             <tbody>
//               {resolvedAlerts.map(alert => (
//                 <tr key={alert.id} className="border-b hover:bg-gray-50">
//                   <td className="py-2 px-3 text-sm">{alert.alert_id}</td>
//                   <td className="py-2 px-3 text-sm">{alert.PMRN}</td>
//                   <td className="py-2 px-3 text-sm">{alert.patient_name}</td>
//                   <td className="py-2 px-3 text-sm">{alert.description}</td>
//                   <td className="py-2 px-3 text-sm">{alert.priority}</td>

//                   <td className="py-2 px-3 text-sm">
//                     {alert.recommendations && alert.recommendations.length > 0 ? (
//                     alert.recommendations.map(item => (
//                       <div key={item.id}>{item.text}</div>
//                     ))
//                     ) : (
//                     <span className="text-gray-400">—</span>
//                    )}
//                   </td>

//                   <td className="py-2 px-3 text-sm">{alert.task_notes && alert.task_notes.length > 0 ? (
//                     alert.task_notes.map(item => (
//                       <div key={item.id}>{item.text}</div>
//                     ))
//                     ) : (
//                     <span className="text-gray-400">—</span>
//                     )}
//                   </td>

//                   <td className="py-2 px-3 text-sm">
//                     {new Date(alert.resolved_at).toLocaleString()}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}

//         {/* If no alerts */}
//         {!loading && resolvedAlerts.length === 0 && (
//           <p className="text-gray-500 text-center py-4">No resolved alerts found.</p>
//         )}
//       </div>
//     </div>
//   );
// }
